import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Actions from "../../../components/actions";
import Defects from "../../../components/defects";
import Complaint from "../../../components/complaint";
import Parts from "../../../components/part";
import ServiceEngineers from "../../../components/service-engineers";
import MailingList from "../../../components/mailing-list";
import Oems from "../../../components/oems";
import OemNames from "../../../components/oem-names";
import Users from "../../../components/users";
import Products from "../../../components/products";
import PastTickets from "../past-ticket";
import PendingServiceInfo from "./pending-service-info";
import PendingServiceBulletins from "./pending-service-bulletins";
import PendingWorkshopManuals from "./pending-workshop-manuals";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

const PendingRequests = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          scrollButtons
          variant="scrollable"
          allowScrollButtonsMobile
          sx={{
            minHeight: "32px",
            marginTop: "10px",
            "& .MuiTab-root": {
              minHeight: "32px",
              fontSize: "12px",
              padding: "4px 8px",
            },
            "& .MuiTabs-indicator": {
              height: "2px",
            },
          }}
        >
          <Tab label="Tickets" />
          <Tab label="Service Information" />
          <Tab label="Service Bulletins" />
          <Tab label="Workshop Manual" />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <PastTickets isShowPendingTickets={true} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <PendingServiceInfo />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <PendingServiceBulletins />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <PendingWorkshopManuals />
      </TabPanel>
    </Box>
  );
};

export default PendingRequests;
